import store from '../redux/configureStore';

const TTL = 30 * 60; // 30 min

const getCache = (key) => {
    key = hashKey(key);

    const cached = localStorage.getItem(key);
    const whenCached = localStorage.getItem(key + ':ttl');

    if (cached !== null && whenCached !== null) {
        let age = (Date.now() - parseInt(whenCached, 10)) / 1000;

        if (age < TTL) {
            return JSON.parse(cached);
        }
    }

    return null;
};

const setCache = (key, data) => {
    key = hashKey(key);

    localStorage.setItem(key, JSON.stringify(data));
    localStorage.setItem(key + ':ttl', Date.now().toString());
};

const hashKey = (s) => {
    const currentLanguage = getCurrentLanguage();

    let hash = 0;
    if (s.length === 0) {
        return hash;
    }

    for (let i = 0; i < s.length; i++) {
        let char = s.charCodeAt(i);
        hash = ((hash<<5)-hash)+char;
        hash = hash & hash; // Convert to 32bit integer
    }

    return 'api_cache_' + currentLanguage + '_' + hash;
};

const getCurrentLanguage = () => {
    const state = store.getState();

    const languages = state.localize.languages;
    let currentLang = 'fr';

    languages.filter(lang => {
        return lang.active === true
    }).map(lang => {
        currentLang = lang.code;
    });

    return currentLang;
};

export {getCache, setCache};



// WEBPACK FOOTER //
// ./src/app/api/cache.js